import { FormVmItemConfigType } from '../../../../../../../../../infrastructure/form-viewmodel-controller';
import { buildConfigList } from '../../../../../../../../../infrastructure/utils/form-config.utils';
import { plainText, requiredIdValidator, richText } from '../../../../../../../../../modules/validators';
import { trimSpacesLeft } from '../../../../../../../../../modules/formatters';

export const FIRST_NAME = 'firstName';
export const LAST_NAME = 'lastName';
export const TITLE = 'title';
export const ACCOUNT_ORGANIZATION_ID = 'accountOrganizationId';
export const BIOGRAPHY = 'biography';

const FORM_CONFIG = {
    [FIRST_NAME]: {
        defaultValue: '',
        validators: [plainText.required, plainText.maxLength.short],
        formatters: [trimSpacesLeft],
    },
    [LAST_NAME]: {
        defaultValue: '',
        validators: [plainText.required, plainText.maxLength.short],
        formatters: [trimSpacesLeft],
    },
    [TITLE]: {
        defaultValue: '',
        validators: [plainText.maxLength.short],
        formatters: [trimSpacesLeft],
    },
    [ACCOUNT_ORGANIZATION_ID]: {
        defaultValue: null,
        validators: [requiredIdValidator],
    },
    [BIOGRAPHY]: {
        defaultValue: '',
        validators: [richText.maxLength.long],
        formatters: [trimSpacesLeft],
    },
};

export const SPEAKER_FORM_CONFIG: FormVmItemConfigType[] = buildConfigList(FORM_CONFIG);